import { NestedModel } from "../nestedmodel";


export class TaskId extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this.addObject = new NestedModel({value: 'addObject', parent: this});
        this.deleteObject = new NestedModel({value: 'deleteObject', parent: this});
        this.executeGroovyScript = new NestedModel({value: 'executeGroovyScript', parent: this});
        this.factoryReset = new NestedModel({value: 'factoryReset', parent: this});
        this.getParameterValues = new NestedModel({value: 'getParameterValues', parent: this});
        this.getParameterAttributes = new NestedModel({value: 'getParameterAttributes', parent: this});
        this.reboot = new NestedModel({value: 'reboot', parent: this});
        this.setParameterValues = new NestedModel({value: 'setParameterValues', parent: this});
        this.setParameterAttributes = new NestedModel({value: 'setParameterAttributes', parent: this});
        this.download = new NestedModel({value: 'download', parent: this});
        this.upload = new NestedModel({value: 'upload', parent: this});
        this.featureSetDeviceTask = new NestedModel({value: 'featureSetDeviceTask', parent: this});
    }
}